var React = require('react');

function Quote (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#FFB000;}\n"),React.createElement("path",{"className":"st0","d":"M16.1,22.6V40H0V26.2C0,18.8,0.9,13.4,2.7,10C5,5.6,8.7,2.3,13.8,0l3.7,5.8c-3.1,1.3-5.3,3.2-6.8,5.7\n\tc-1.4,2.5-2.3,6.2-2.4,11h7.8V22.6z M41.9,22.6V40H25.8V26.2c0-7.4,0.9-12.8,2.7-16.2c2.3-4.4,6-7.8,11.1-10.1l3.7,5.8\n\tC40.2,7,38,8.9,36.5,11.4c-1.4,2.5-2.3,6.2-2.4,11h7.8V22.6z","key":1})]);
}

Quote.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 44 40","style":{"enableBackground":"new 0 0 44 40"},"xmlSpace":"preserve"};

module.exports = Quote;

Quote.default = Quote;
